import {AbstractModel} from '../abstract-model';
import {SimpleStat} from './simple-stat';

export class PartnerTypeStat extends AbstractModel {
  affiliate: SimpleStat = new SimpleStat();
  internal: SimpleStat = new SimpleStat();
  mediabuy: SimpleStat = new SimpleStat();
  totals: SimpleStat = new SimpleStat();

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.affiliate) {
      this.affiliate = new SimpleStat().deserialize(input.affiliate);
    }

    if (input.internal) {
      this.internal = new SimpleStat().deserialize(input.internal);
    }

    if (input.mediabuy) {
      this.mediabuy = new SimpleStat().deserialize(input.mediabuy);
    }

    if (input.totals) {
      this.totals = new SimpleStat().deserialize(input.totals);
    }

    return this;
  }
}
